export const AGENCY_SELF_PROJECTS_LABEL = 'My Projects';

export function isAgencySelfProfileClient(
  client: { email?: string },
  agencyEmail?: string | null,
  isAgency?: boolean,
): boolean {
  return Boolean(
    isAgency &&
      agencyEmail &&
      client.email &&
      client.email.trim().toLowerCase() === agencyEmail.trim().toLowerCase(),
  );
}

export function agencyClientDisplayName(
  client: { email?: string; name: string },
  agencyEmail?: string | null,
  isAgency?: boolean,
): string {
  return isAgencySelfProfileClient(client, agencyEmail, isAgency)
    ? AGENCY_SELF_PROJECTS_LABEL
    : client.name;
}
